







import { Component, Emit, Prop, Vue } from "vue-property-decorator";

@Component
export default class Item extends Vue {
  @Prop() private name!: string;
  @Prop() private value!: string;

  @Emit("updateValue")
  updateValue() {
    //
  }
}
